import React, { FC, useEffect, useState } from 'react'
import SAAlert from 'components/SA/Alert'
import Modal from 'components/SA/Modal/v2'
import styles from '../CollectionDetails.module.scss'
import useModal from 'hooks/useModal'
import { postCollectionFeedback } from 'apis/aa'
import TextAreaLabel from 'components/SA/FormElements/TextareaLabel'
import { isSessionSet } from 'selectors/user/session'
import { useSelector } from 'react-redux'
import useQA from 'hooks/useQA'

const FEEDBACK_MODAL_NAME = 'FEEDBACK_MODAL_NAME'

type FeedbackModalProps = {
  isAdmin: boolean
  collectionOwnerName: string
  idUserCollection: number
}

const FeedbackModal: FC<FeedbackModalProps> = ({
  isAdmin,
  collectionOwnerName,
  idUserCollection,
}) => {
  const { testId } = useQA()
  const [selectionFeedback, setSelectionFeedback] = useState('')

  const { showModal, closeModal } = useModal()
  const isSet = useSelector(isSessionSet)

  const onChange = (ev: React.SyntheticEvent<HTMLElement>) => {
    ev.preventDefault()
    const { value } = ev.target
    setSelectionFeedback(value)
  }

  const openFeedbackModal = () => {
    showModal(FEEDBACK_MODAL_NAME)
  }

  const sendFeedback = async () => {
    const { success } = await postCollectionFeedback(idUserCollection, selectionFeedback)

    if (success) {
      setSelectionFeedback('')
      closeModal()
    }
  }

  useEffect(() => {
    openFeedbackModal()
  }, [])

  if (!isSet || isAdmin) {
    return null
  }

  return (
    <>
      <div className={styles.feedbackContainer} onClick={openFeedbackModal}>
        <SAAlert
          type='info'
          text={`Submit feedback to ${collectionOwnerName}`}
          alertStyles={styles.feedbackAlertCustomStyle}
        />
      </div>

      <Modal name={FEEDBACK_MODAL_NAME} layout='standard' isCloseButtonVisible>
        <div className={styles.feedbackModalContainer} {...testId('feedback-modal-container')}>
          <h3>Please submit feedback to finish</h3>
          <p>
            Please use the thumbs up and down buttons to compile a shortlist of the works you like
            and do not like. You can add additional comments below so I can best help in the next
            step of this process. And do remember that the prices you see listed include shipping!
            <div>
              <br />
              <p>Best,</p>
              <p>{collectionOwnerName}</p>
            </div>
          </p>

          <TextAreaLabel
            name='feedback'
            value={selectionFeedback}
            title=''
            onChange={onChange}
            styleOverride={styles.fullWidth}
            maxLength={250}
          />
          <button onClick={sendFeedback}>Send</button>
        </div>
      </Modal>
    </>
  )
}

export default FeedbackModal
